import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gradient-to-r from-oliva-dark to-oliva text-white text-center py-3 px-4 font-body text-sm sm:text-base font-bold sticky top-0 z-50 shadow-md" data-id="element-287">
      <div className="container mx-auto" data-id="element-288">
        <span className="mr-2" data-id="element-289">⏳ OFERTA POR TIEMPO LIMITADO</span>
        <span className="hidden sm:inline mx-2" data-id="element-290">|</span>
        <span className="text-mostaza-light" data-id="element-291">
          75% DE DESCUENTO + 2 REGALOS GRATIS
        </span>
        <span className="hidden sm:inline mx-2" data-id="element-292">|</span>
        
      </div>
    </div>;
}